module.exports = __webpack_public_path__ + "static/media/LogoApp.203fcf65.png";